var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterConsumptionChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2067_22644",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 5,
    fill: "#384663"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2067_22644)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 5,
    fill: "#2E3A54"
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.2,
    x1: -3.48195e-9,
    y1: 5.46436,
    x2: 40,
    y2: 5.46436,
    stroke: "#5C73A4",
    strokeWidth: 0.5,
    strokeDasharray: "4 1.2"
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.2,
    x1: -3.48195e-9,
    y1: 11.1787,
    x2: 40,
    y2: 11.1787,
    stroke: "#5C73A4",
    strokeWidth: 0.5,
    strokeDasharray: "4 1.2"
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.2,
    x1: -3.48195e-9,
    y1: 16.8931,
    x2: 40,
    y2: 16.8931,
    stroke: "#5C73A4",
    strokeWidth: 0.5,
    strokeDasharray: "4 1.2"
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.2,
    x1: -3.48195e-9,
    y1: 22.6072,
    x2: 40,
    y2: 22.6072,
    stroke: "#5C73A4",
    strokeWidth: 0.5,
    strokeDasharray: "4 1.2"
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.2,
    x1: -3.48195e-9,
    y1: 28.3213,
    x2: 40,
    y2: 28.3213,
    stroke: "#5C73A4",
    strokeWidth: 0.5,
    strokeDasharray: "4 1.2"
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.2,
    x1: -3.96868e-9,
    y1: 34.0356,
    x2: 40,
    y2: 34.0356,
    stroke: "#5C73A4",
    strokeWidth: 0.5,
    strokeDasharray: "4 1.2"
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.2,
    x1: -3.96868e-9,
    y1: 39.75,
    x2: 40,
    y2: 39.75,
    stroke: "#5C73A4",
    strokeWidth: 0.5,
    strokeDasharray: "4 1.2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 11.6951,
    width: 3.78049,
    height: 22.3049,
    fill: "#4d9eea"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.9902,
    y: 5.26831,
    width: 3.78049,
    height: 28.7317,
    fill: "#4d9eea"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.9805,
    y: 17.366,
    width: 3.78049,
    height: 16.6341,
    fill: "#4d9eea"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.9727,
    y: 8,
    width: 3.78049,
    height: 26,
    fill: "#4d9eea"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterConsumptionChart);
export default __webpack_public_path__ + "static/media/water-consumption-chart.8ad853fe.svg";
export { ForwardRef as ReactComponent };